// Presentation only. Preserve API timestamps, raw durations and CSV exports.
export const attendanceMinutes = value => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) ? String(Math.floor(Math.max(0, Number(value)))) : '—';
